/* eslint-disable import/prefer-default-export */
export var BUTTON_TYPES = {
  BIG: 'big',
  BORDERED: 'bordered',
  BORDERED_HOVER: 'borderedHover',
  BORDERED_INVERSE_HOVER: 'borderedInverseHover',
  DEFAULT: 'big',
  GRAY: 'gray',
  LINK_STYLE: 'linkStyle',
  MEDIUM: 'medium',
  SMALL: 'small',
  WHITE: 'white'
};
export var BLOCK_DEFAULTS = {
  adminTitle: '',
  blockType: 'DESKTOP',
  buttonType: 'DEFAULT',
  buttonTypeExtra: 'DEFAULT',
  cta: '',
  ctaExtra: '',
  image: false,
  imageHover: false,
  imagePosition: 'RIGHT',
  layout: 'RIGHT_LEFT',
  overlay: false,
  rawHtml: '',
  subtitle: '',
  subtitleColor: '#ffffff',
  title: '',
  titleColor: '#ffffff',
  url: '',
  urlExtra: ''
}; // export const IMAGE_POSITIONS = {
//   TOP: 'Image Top (text bottom)',
//   RIGHT: 'Image Right (text left)',
//   BOTTOM: 'Image Bottom (text top)',
//   LEFT: 'Image Left (text right)',
//   CENTER: 'Image Center (text center)',
// };